import React from 'react';

import FormDate from '../../../../../Forms/Common/FormDate';
import { QuestionTypeShowProps } from './QuestionShow';

export default function DateShow({
  errors,
  index,
  errorIndex,
  form,
  disabled,
  scope,
}: QuestionTypeShowProps) {
  const { control } = form;
  const name = `${scope}answers_attributes.${index}.date`;
  const errorPath = `${scope}answers_attributes.${errorIndex}.date`;

  return (
    <FormDate
      control={control}
      name={name}
      errorPath={errorPath}
      errors={errors}
      disabled={disabled}
      dateOnly
    />
  );
}
